<form>
    <dialog-wrapper>
        <span jeDialogTitle>{{ 'ERROR_SUBMIT.HEADLINE' | translate }}</span>
        <div>
            <label>{{ 'ERROR_SUBMIT.HINT' | translate }}</label>
            <bsm-textarea [value]="errorText" (valueChange)="errorText = $event" [disabled]="isProcessing$ | async" [minRows]="8"> </bsm-textarea>
            <div [ngClass]="{ 'bg-gray-300 dark:bg-gray-800': file }" class="border border-solid border-black-500 p-4 rounded relative">
                <input #fileInput (change)="screenshotUploaded($event)" accept="image/*,application/pdf" type="file" />
                @if (file) {
                    <button (click)="resetFileInput()" class="absolute top-[18px] right-[5px] h-11">
                        <je-fa-icon [name]="'xmark'"></je-fa-icon>
                    </button>
                }
            </div>
            @if (this.errorMessage) {
                <je-message-box [type]="'error'">
                    <span>{{ this.errorMessage | translate }}</span>
                </je-message-box>
            }
        </div>
        <div jeDialogFooter class="flex justify-end gap-2">
            <je-button [label]="'ERROR_SUBMIT.BACKBUTTONTEXT' | translate" variant="secondary" (onClick)="onBackButtonClick()"></je-button>
            <je-button
                [label]="'ERROR_SUBMIT.SEND' | translate"
                variant="secondary"
                (onClick)="onSubmitButtonClick()"
                [disabled]="isProcessing$ | async"
                class="ml-auto"></je-button>
        </div>
    </dialog-wrapper>
</form>
